var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "notice-preview" },
    [
      _c("h3", [_vm._v("公告内容与附件")]),
      _vm.preview.unavailable
        ? _c("el-alert", {
            attrs: {
              title: _vm.preview.message,
              type: "warning",
              closable: false,
            },
          })
        : [
            _c(
              "el-button",
              {
                attrs: { type: "primary", plain: "", size: "small" },
                on: {
                  click: function ($event) {
                    _vm.showContent = true
                  },
                },
              },
              [_vm._v("公告内容预览")]
            ),
            _c("div", { staticClass: "notice-files-title" }, [
              _vm._v("附件（" + _vm._s(_vm.files.length) + "）"),
            ]),
            _c("approval-attachment-list", { attrs: { files: _vm.files } }),
            !_vm.files.length
              ? _c("p", { staticClass: "notice-empty" }, [_vm._v("暂无附件")])
              : _vm._e(),
          ],
      _c(
        "el-dialog",
        {
          attrs: {
            title: "公告内容预览",
            visible: _vm.showContent,
            "append-to-body": "",
            width: "80%",
            top: "5vh",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showContent = $event
            },
          },
        },
        [
          _c("h2", [_vm._v(_vm._s(_vm.preview.title))]),
          _vm.preview.author
            ? _c("p", [_vm._v(_vm._s(_vm.preview.author))])
            : _vm._e(),
          _vm.showContent
            ? _c("iframe", {
                staticClass: "notice-content-frame",
                attrs: {
                  srcdoc: _vm.contentHtml,
                  sandbox: "",
                  title: "公告正文只读预览",
                },
              })
            : _vm._e(),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.showContent = false
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }